
<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import PedidoFiltro from '../components/pedido-filtro'
import FvPedidoForm from './fv-pedido-form'
import PedidoStatus from '../forms/pedido-status'
import PedidoStatusShare from '../forms/pedido-status-share'
import PedidoImpressao from '../forms/pedido-impressao.vue'
import { apiORDSpost, apiDownloadPDF, apiDownload, apiEmailPDF, apiDateORDS } from '../shared/api-functions'
import { getText, formatDate, formatDataHoraExtenso } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpedv: '',
            filter: '',
            monthQuery: '',
            textQuery: '',
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            metadata: this.$store.getters.getEntities.metadata,

            offset: false,
            monthFilter: {},

            pedv_update_status: {},
            pedv_share_status: {},

            query: {
                codusuario: null,
                codequipe: null,
                text: null,
                after: null,
                before: null,
                codstatus: null,
            },

            partOptions: [
                {id: 'C', text: 'Cliente'},
                {id: 'F', text: 'Fornecedor'},
                {id: 'T', text: 'Transportadora'}
            ],

            codpedvImpressao: null,
            showImpressao: false,

            usingFiltros: false,

            paramsFiltro: {
              periodos: [

                {
                  label: "Data Pedido / Orçamento",
                  nome: "dta",
                  varios: false,
                  values:[
                    {
                      data_inicio: null,
                      data_termino: null,
                    }
                  ]
                },
                {
                  label: "Data da validade (Orçamentos)",
                  nome: "dtvalidade",
                  varios: false,
                  values:[
                    {
                      data_inicio: null,
                      data_termino: null,
                    }
                  ]
                },

              ],

              selects: [

                {
                  label:"Dias Validade (Orçamentos)",
                  nome:"diasvalidade",
                  placeholder: "Tipo dias validade",
                  id: null,
                  value:null,
                  value_label:"em até",
                  value_placeholder: "Quantidade de Dias Validade (Orçamentos)",
                  options: [
                    {
                      id: "0",
                      text: "Vencidos",
                    },
                    {
                      id: "1",
                      text: "À vencer",
                    },

                  ]
                },

              ],

              filtros: [
              /*
                {
                  nome: "filial",
                  label: null,
                  url: null,
                  varios: false,
                  values: []
                  },
                {
                  nome: "segmento",
                  label: null,
                  url: null,
                  varios: true,
                  values: [],
                },
                {
                  nome: "grupocliente",
                  label: null,
                  url: null,
                  varios: true,
                  values: [],
                },
                {
                  nome: "estado",
                  label: null,
                  url: null,
                  varios: true,
                  values: []
                },
                */
             ],
            },


        }
    },

    components: {
        BarList, BarGrid, FilterList, FvPedidoForm, PedidoFiltro, PedidoStatus, PedidoStatusShare, PedidoImpressao
    },

    computed: {

        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        notFound: function () {
            if (this.query.filtros){
              return 'Nenhum pedido encontrado para o período';
            }else{
              return 'Nenhum pedido encontrado para o período ' + formatDate(this.monthFilter.startDate) + ' a ' + formatDate(this.monthFilter.endDate)
            }
        },

        pedvList: function () {
            return this.$store.getters.getPedvList;
        },

        pedvTotal: function () {
           return this.$store.getters.getPedvTotal
        },

        appLoja: function () {
            return SysVars.appLoja
        },

        bloqueia_alterar_pedido: function () {
            console.log(this.$store.getters.getParametrosUsuario)
            console.log(this.$store.getters.getParametrosUsuario.vendas)
            if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
              return this.$store.getters.getParametrosUsuario.vendas.bloqueia_alterar_pedido
            else
              return false
        },


    },

    watch: {
        pedvTotal: function () {

            //AQUI MONTA O OBJETO PARA A LISTA DE FILTROS DO COMPONENTE filter-list BASEADO NO OBJETO DE TOTAIS CARREGADO DO SERVIDOR

            this.filterList = []
            let total = {}

            let tot = 0

            if (this.pedvTotal.length > 0 && this.pedvTotal[this.pedvTotal.length-1].status == 'TOTAL') {
              tot = this.pedvTotal[this.pedvTotal.length-1].total
            }

            for (let i = 0; i < this.pedvTotal.length; i++) {
                total = {}
                total.label = ''
                total.total = this.pedvTotal[i].total
                total.qt = this.pedvTotal[i].qt
                total.status = this.pedvTotal[i].status
                if (total.status == 'ORCAMENTO') {
                    total.label = 'Orçamentos'
                } else if (total.status == 'PERDIDO') {
                    total.label = 'Orçamentos Perdidos'
                } else if (total.status == 'VENDA') {
                    total.label = 'Vendas'
                } else if (total.status == 'TOTAL') {
                    total.label = 'Total Geral'
                }

                //calcula o % em relacao ao total
                if (tot > 0) {
                    total.perc = total.total / tot * 100
                }

                this.filterList.push({...total})
            }

            this.paramFilterList = { total: this.filterList, selectedStatus: '' }

        },

    },

    filters: {

    },

    methods: {
        scroll () {
          window.onscroll = () => {
            if (this.showForm || this.offset || this.nextPage == 0)
              return
            let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= (document.documentElement.offsetHeight - 2)

            if (bottomOfWindow) {
              this.offset = true
              this.loadData(true)
            }
            SysVars.scrollPosition = document.documentElement.scrollTop
          }
        },

        notFoundMsg() {
            if (this.query.filtros){
              return 'Nenhum pedido encontrado para o período';
            }else{
              return 'Nenhum pedido encontrado para o período ' + formatDate(this.monthFilter.startDate) + ' a ' + formatDate(this.monthFilter.endDate)
            }
        },


        horaStatus (hora) {
            return formatDataHoraExtenso(hora)

        },

        handleDownloadXML(codnf, chave) {
            //visualizacao do XML da NFE
            var data = {codnf: codnf, chave: chave, tipo: 'NFE' }
            apiDownload(this, 'print/xmlnfe/', data, 'post')
        },


        handleShareStatus(item) {
            this.pedv_share_status = item
        },

        async handlePostShareStatus() {
            this.pedv_share_status = {}
        },



        handleUpdateStatus(item) {
            this.pedv_update_status = item
        },

        async handlePostStatus() {
            var modulo = 'sales/statuspedido/' + this.pedv_update_status.codpedv

            let sendData = {
                pedv: {
                    codpedv: this.pedv_update_status.codpedv,
                    codstatus: this.pedv_update_status.codstatus,
                    obs: '',
                }
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, 'post')
            if (data) {
              this.pedv_update_status.status = data.descricao
              this.pedv_update_status = {}
            }
        },


        formataEndereco: function (pedv) {
            if (pedv.ecommerce != 'S')
              return null
            let end = pedv.cliente.endereco
            if (end) {
                if (pedv.cliente.nr)
                end = end + ', ' + pedv.cliente.nr
                if (pedv.cliente.bairro)
                end = end + ', ' + pedv.cliente.bairro
                end = end + ', ' + pedv.cliente.cidade + ' - ' + pedv.cliente.uf + ' - ' + pedv.cliente.cep
                pedv.cliente.endereco_completo = end
            }
            return end
        },

        statusColor: function (stpedv, tppedv) {
            let color = 'badge-green'
            if (stpedv == 'C' || stpedv == 'R' || tppedv == 'R') {
                color = 'badge-red'
            } else if (stpedv == 'F') {
                color = 'badge-blue'
            } else if (tppedv == 'O') {
                color = 'badge-orange'
            } else if (tppedv == 'P') {
                color = 'badge-green'
            }
            return color
        },
        handleEditPedido (pedido, view) {
            //abre a tela de edicao
            if (view || pedido.data_leitura)
              this.crud = SysVars.crudView
            else
              this.crud = SysVars.crudU //operacao de edicao
            this.codpedv = pedido.codpedv //numero do pedido
            this.$store.dispatch('cleanpart')
            this.showForm = true; //exibe o form de manutencao
        },
        handleClosePrint () {
            this.showImpressao = false
        },
        handleAction (act, codpedv) {
            if (act == 1) {
                this.codpedvImpressao = codpedv
                this.showImpressao = true
                this.$nextTick(function () {
                    this.$refs.impressao.print()
                })
            }
            else if (act == 2) {
                //faturar
                this.$router.push('/nf/' + codpedv)
            }
        },
        handleNovoPedido () {
            //abre a tela de edicao
            this.crud = SysVars.crudI //operacao de inclusao
            this.codpedv = '';
            this.$store.dispatch('cleanpart')
            this.showForm = true; //exibe o form de manutencao
        },

        closeForm() {
            this.showForm = false
            this.$scrollTo(0)
            this.loadData()
        },

        changeFiltros (filtros) {
            this.query.text = null
            this.query.filtros = { ...filtros }
            this.loadData()
        },

        changeFiltroTexto(value) {
            //efetua a pesquisa por texto
            this.query.text = value.toUpperCase()
            this.query.after = null
            this.query.before = null
            this.query.filtros = null
            this.loadData()
        },

        changeFiltroMes (filter, startDate, endDate) {
            this.query.after = startDate
            this.query.before = endDate
            this.query.text = null
            this.query.filtros = null
            this.loadData()
        },

        handleFilterList (status) {
            //CLICK DO FILTER LIST
            if (status === 'TOTAL') {
                this.statusQuery = ''
            } else {
                this.statusQuery = 'status=' + status
            }
            this.loadData()
        },

        loadData(nottotal) {
            let param = {}
            param.query = ''

            if (this.query.text)
              param.query = param.query + 'text=' + this.query.text + '&'
            if (this.query.after)
              param.query = param.query + 'after=' + this.query.after + '&'
            if (this.query.before)
              param.query = param.query + 'before=' + this.query.before + '&'
            if (this.query.codusuario)
              param.query = param.query + 'usuario=' + this.query.codusuario + '&'
            if (this.query.codequipe)
              param.query = param.query + 'equipe=' + this.query.codequipe + '&'
            if (this.query.codstatus)
              param.query = param.query + 'codstatus=' + this.query.codstatus + '&'
            if (this.query.codfrete)
                param.query = param.query + 'codfrete=' + this.query.codfrete + '&'
            if (this.statusQuery)
              param.query = param.query + this.statusQuery + '&'
            if (this.offset)
              param.query = param.query + 'poffset=' + this.nextPage + '&'

            param.query = param.query.trim()
            if (param.query.endsWith('&'))
              param.query = param.query.slice(0,-1)

            this.usingFiltros = false
            if (this.query.filtros){
              param.body = JSON.stringify(this.query.filtros);
              this.usingFiltros = true
            }

            console.log(param)

            this.$store.dispatch('loadPedidosFvList', param)
            this.offset = false

            if (!nottotal)
               this.$store.dispatch('loadPedidosFvTotal', param)


            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },
        textST (pedv) {
            let text = 'Pedido'
            if (pedv.varejo == 'S')
              text = 'Venda Varejo'
            if (pedv.tppedv == 'O') {
                text = 'Orçamento'
            } else if (pedv.tppedv == 'R') {
                text = 'Orçamento Perdido'
                return text
            }

            if (pedv.stpedv == 'C')
                text = text + ' Cancelado'
             else if (pedv.stpedv == 'R')
                text = text + ' Rejeitado'
             else if (pedv.stpedv == 'A')
                text = text + ' Em Aprovação'
             else if (pedv.stpedv == 'F')
                text = text + ' Faturado'

            return text
        },
        enablePrint (st) {
            return (st == 'P' || st == 'F')
        },
        enableEdit (st, cieloidsuperlink, vendarecebida, tp) {
            let result = false

            if ((st === 'P' || st === 'D') && !(vendarecebida == 'S'))
              result = true

            if ((tp === 'P') && (this.bloqueia_alterar_pedido))
              result = false

            return result
        },
        enableFaturar (st, tp) {
            return (st === 'P' && tp === 'P') //somente pedido pendente
        },

        orcamentoVencido(item){
            return (item.tppedv == 'O' && item.stpedv == 'P' && item.dtvalidade && (new Date(item.dtvalidade).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)))
        },

    },

    mounted () {
        this.query.after = apiDateORDS(this.monthFilter.startDate)
        this.query.before = apiDateORDS(this.monthFilter.endDate, true)
        this.query.text = null
        this.query.filtros = null
        this.loadData()
        this.showForm = false
        this.scroll()
        console.log(window.onscroll)
    },

    created () {
        //this.$store.dispatch('clearItemSales')

        //carrega parametros do usuario para bloqueio das tabelas de precos
        this.$store.dispatch('loadParametrosUsuario')
    },

    destroyed () {
        window.onscroll = null
        console.log(window.onscroll)
    },


}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm">

            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="false"
                :filter-month="true"
                single-entity="Orçamento/Venda"
                plural-entity="Orçamentos/Vendas"
                :month-filter="monthFilter"
                @search="changeFiltroTexto"
                @new="handleNovoPedido"
                @refresh="loadData"
                @filter="changeFiltroMes"
                title-search="Pesquise pelo número ou nome do cliente ou cnpj/cpf">
            </bar-list>
            <br>

            <pedido-filtro
                :filter-tipos="true"
                :filter-equipes="true"
                :filter-usuarios="true"
                :filter-status="true"
                :filter-frete="true"
                :params="paramsFiltro"
                :in-use="usingFiltros"
                :query="query" @change="changeFiltros" @cancel="changeFiltros"></pedido-filtro>

            <filter-list :params="paramFilterList" @select="handleFilterList"></filter-list>

            <div class="default-container p-0">
                <alert v-if="pedvList.length == 0" type="warning" :text="notFoundMsg()"></alert>
                <div class="w-100" style="margin: 5px 0 5px; border-bottom: 1px solid #eee;" v-for="item in pedvList" v-bind:key="item.codpedv">
                    <!-- <div v-bind:class="[{ 'mark-yellow': (item.stpedv === 'D') }, { 'mark-green': (item.stpedv === 'P') }, { 'mark-red': (item.stpedv === 'C' || item.stpedv === 'R') }]"></div> -->
                    <!-- <div class="mark-gray"></div> -->
                    <div class="row p-3">
                        <div class="col-md-7 d-none d-md-block">
                            <div class="row">
                                <div class="col-md-12 col-12">
                                    <span class="lbl-list" v-if="item.tppedv=='P'"> Pedido </span>
                                    <span class="lbl-title-produto" v-if="item.tppedv=='P'" title="Número do Pedido"> #{{ item.npedido }}</span>
                                    <span class="lbl-list"> Orçamento </span>
                                    <span class="lbl-title-produto" title="Número do Orçamento"> #{{ item.ncotacao }}</span>
                                    <span class="lbl-list px-3"><i class="fa fa-user mr-2"></i> {{ item.nome_usuario }} </span>
                                    <span class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.data | formatDataExtenso }}</span>
                                    <span v-if="item.dtvalidade && item.tppedv=='O' " class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i>Validade {{ item.dtvalidade | formatDataExtenso }}</span>
                                    <!-- <span v-if="item.data_leitura" class="badge badge-yellow ml-2" data-toggle="tooltip" data-placement="top" :title="item.data_leitura">Leitura Efetuada</span> -->
                                    <span v-if="orcamentoVencido(item)" class="badge badge-red mr-2" data-toggle="tooltip" data-placement="top" title="Orçamento com data de validade vencida"><i class="fa fa-calendar pr-2" aria-hidden="true"></i>Vencido</span>
                                </div>
                                <div class="col-md-12 col-12">
                                    <span class="lbl-title-produto">{{ item.nome }}</span>
                                    <span class="data-list-sm w-100">{{ item.cnpjcpf | formatCNPJCPF }} - {{ item.bairro }} - {{ item.uf }}</span>
                                    <span v-if="item.fone1" class="data-list-sm"><i class="fa fa-phone" aria-hidden="true"></i> {{ item.fone1 | formatFone }} </span>
                                    <span v-if="item.email" class="data-list-sm"><i class="fa fa-envelope" aria-hidden="true"></i> {{ item.email }} </span>
                                    <!-- <span class="data-list">{{ item.codpart }}</span> -->
                                </div>
                                <div class="col-md-6 col-12">
                                    <span class="data-list-sm">R$ <strong>{{ item.totger | formatValue(2) }}</strong></span>
                                </div>
                                <div class="col-12 other-device" v-if="item.negocio_titulo">
                                    <a class="data-list mr-2" :href="'#/crm/negocio/'+item.codnegocio" data-toggle="tooltip" data-placement="top" :title="'Vinculado ao negócio ' + item.negocio_titulo"><i class="fa fa-dollar mr-2" aria-hidden="true"></i>{{ item.negocio_titulo }}</a>
                                </div>
                                <div v-if="item.datanfsync" class="col-12 other-device">
                                    <label class="lbl-edit">Faturado em</label>
                                    <span class="data-list-sm">{{ item.datanfsync | formatData }}</span>
                                    <label class="lbl-edit">Nota Fiscal</label>
                                    <span class="data-list-sm">{{ item.nfsync }}</span>
                                    <label v-if="item.chavenfsync" class="lbl-edit">Chave</label>
                                    <span v-if="item.chavenfsync" class="data-list-sm">{{ item.chavenfsync }}</span>
                                </div>
                                <div v-if="item.comissao && item.comissao.length > 0" class="col-12 other-device">
                                    <label class="lbl-edit">Base Comissão</label>
                                    <span class="data-list-sm">{{ item.comissao[0].bcomi | formatValue(2) }}</span>
                                    <label class="lbl-edit">% Comissão</label>
                                    <span class="data-list-sm">{{ item.comissao[0].pcomi | formatValue(2) }}</span>
                                    <label class="lbl-edit">Valor Comissão</label>
                                    <span class="data-list-sm">{{ item.comissao[0].vcomi | formatValue(2) }}</span>
                                </div>
                           </div>
                        </div>
                        <div class="col-md-5 d-md-block d-none">
                            <div class="row">
                                <div class="col-md-12 mb-2 text-right">
                                    <span v-if="item.data_leitura" class="badge badge-yellow ml-2" data-toggle="tooltip" data-placement="top" :title="'Leitura efetuada em ' + item.data_leitura"><i class="fa fa-check" aria-hidden="true"></i></span>
                                    <span class="badge badge-error mr-2" v-if="appLoja && item.tppedv == 'P' && item.stfraud == '3'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Reprovado Clearsale </span>
                                    <span class="badge badge-success mr-2" v-if="appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.stfraud == '2'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Clearsale </span>
                                    <!-- <span class="badge badge-warning mr-2" v-if="appLoja && item.tppedv == 'P' && (!item.cieloidsuperlink)"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Link pagamento Cielo não gerado </span> -->
                                    <span class="badge badge-warning mr-2" v-if="appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.cieloidsuperlink && item.vendarecebida != 'S' && item.vendarecebida != 'N'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Aguardando Pagamento Online </span>
                                    <span class="badge badge-warning mr-2" v-if="appLoja && item.tppedv == 'P' && item.cieloidsuperlink && item.vendarecebida == 'N'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Pagamento Não realizado </span>
                                    <span class="badge badge-success mr-2" v-if="appLoja && item.tppedv == 'P' && item.vendarecebida == 'S'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Pagamento Efetuado </span>
                                    <span v-if="item.ecommerce == 'S'" class="badge badge-warning"><i class="fa fa-shopping-basket"></i></span>
                                    <span class="badge" :class="statusColor(item.stpedv, item.tppedv)">{{ textST(item) }}</span>
                                </div>
                                <div class="col-md-12 align-items-right">
                                    <v-button class="float-right" icon="fa-share-alt" title="Compartilhar o status do pedido" @click="handleShareStatus(item)"></v-button>
                                    <v-button class="float-right" icon="fa-exclamation-circle" title="Definir o status do pedido" @click="handleUpdateStatus(item)"></v-button>
                                    <v-button v-if="item.stpedv == 'F' && item.codnf && item.chave" label="xml" :not_min_width="true" class="float-right" title="Baixar XML da NF-e" @click="handleDownloadXML(item.codnf, item.chave)">xml </v-button>
                                    <bar-grid
                                        :options="{barDefault: true, btnView: true, btnEdit: enableEdit(item.stpedv, item.cieloidsuperlink, item.vendarecebida, item.tppedv), btnPrint: enablePrint(item.stpedv), btnFaturar: false}"
                                        :moreActions="[]"
                                        @edit="handleEditPedido(item)"
                                        @view="handleEditPedido(item, true)"
                                        @print="handleAction(1, item.codpedv)"
                                        @faturar="handleAction(2, item.codpedv)"
                                        @action="handleAction(id, item.codpedv)">
                                    </bar-grid>
                                    <pedido-status v-if="pedv_update_status.codpedv == item.codpedv" :pedv="item" @closeform="pedv_update_status = {}" @save="handlePostStatus"></pedido-status>
                                    <pedido-status-share v-if="pedv_share_status.codpedv == item.codpedv" :pedv="item" @closeform="pedv_share_status = {}" @save="handlePostShareStatus"></pedido-status-share>
                                </div>
                                <div class="col-12 mt-2 text-right">
                                    <span v-if="item.stpedv != 'C' && item.status" class="badge badge-warning" :title="horaStatus(item.datastatus)"> <i class="fa fa-exclamation-circle mr-2" aria-hidden="true"></i> {{ item.status }} </span>
                                    <!-- <v-button :link="true" icon="fa-pencil" label="Status" title="Definir o status do pedido" @click="handleUpdateStatus(item)"></v-button> -->
                                   <span v-if="item.stpedv != 'C' && item.ecommerce == 'S' && item.clienteretira == 'S'" class="badge badge-info mr-2"><i class="fa fa-truck mr-2" aria-hidden="true"></i> Retirar no local</span>
                                   <span v-if="item.stpedv != 'C' && item.ecommerce == 'S' && item.clienteretira == 'N' && item.descricaofrete" class="badge badge-info mr-2"><i class="fa fa-truck mr-2" aria-hidden="true"></i> {{ item.descricaofrete }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- MOBILE -->
                        <div class="col-12 d-md-none d-xs-block">
                            <div class="row">
                                <div class="col-12 mb-2">
                                    <span class="lbl-list" v-if="item.tppedv=='P'"> Pedido </span>
                                    <span class="lbl-title-produto" v-if="item.tppedv=='P'" title="Número do Pedido"> #{{ item.npedido }}</span>
                                    <span class="lbl-list" v-if="item.tppedv=='O'"> Orçamento </span>
                                    <span class="lbl-title-produto" v-if="item.tppedv=='O'" title="Número do Orçamento"> #{{ item.ncotacao }}</span>
                                    <span class="lbl-list"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.data | formatData }}</span>
                                    <span class="lbl-list"><i class="fa fa-user mr-2"></i> {{ item.nome_usuario }} </span>
                                </div>
                                <div class="col-12 mb-2">
                                    <span class="badge" :class="statusColor(item.stpedv, item.tppedv)">{{ textST(item) }}</span>
                                    <span v-if="item.ecommerce == 'S'" class="badge badge-warning"><i class="fa fa-shopping-basket"></i></span>
                                    <span v-if="item.dtvalidade && item.tppedv=='O'" class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i>Validade {{ item.dtvalidade | formatDataExtenso }}</span>
                                    <span v-if="orcamentoVencido(item)" class="badge badge-red mr-2" data-toggle="tooltip" data-placement="top" title="Orçamento com data de validade vencida"><i class="fa fa-calendar pr-2" aria-hidden="true"></i>Vencido</span>
                                    <span v-if="item.data_leitura" class="badge badge-yellow ml-2" data-toggle="tooltip" data-placement="top" :title="'Leitura efetuada em ' + item.data_leitura"><i class="fa fa-check" aria-hidden="true"></i></span>
                                </div>
                                <div class="col-12">
                                    <span class="lbl-deal-title d-block">{{ item.nome }}</span>
                                    <span v-if="item.fone1" class="data-list-sm"><i class="fa fa-phone" aria-hidden="true"></i> {{ item.fone1 | formatFone }} </span>
                                    <span v-if="item.email" class="data-list-sm"><i class="fa fa-envelope" aria-hidden="true"></i> {{ item.email }} </span>
                                </div>
                                <div class="col-12 mb-2">
                                    <span class="data-list-sm">R$ <strong>{{ item.totger | formatValue(2) }}</strong></span>
                                    <v-button class="float-right" icon="fa-share-alt" title="Compartilhar o status do pedido" @click="handleShareStatus(item)"></v-button>
                                    <v-button class="float-right" icon="fa-exclamation-circle" title="Definir o status do pedido" @click="handleUpdateStatus(item)"></v-button>
                                    <v-button v-if="item.stpedv == 'F' && item.codnf && item.chave" label="xml" :not_min_width="true" class="float-right" title="Baixar XML da NF-e" @click="handleDownloadXML(item.codnf, item.chave)">xml </v-button>
                                    <bar-grid
                                        :options="{barDefault: true, btnView: true, btnEdit: enableEdit(item.stpedv, item.cieloidsuperlink, item.vendarecebida, item.tppedv), btnPrint: enablePrint(item.stpedv), btnFaturar: false}"
                                        :moreActions="[]"
                                        @edit="handleEditPedido(item)"
                                        @view="handleEditPedido(item, true)"
                                        @print="handleAction(1, item.codpedv)"
                                        @faturar="handleAction(2, item.codpedv)"
                                        @action="handleAction(id, item.codpedv)">
                                    </bar-grid>
                                    <pedido-status v-if="pedv_update_status.codpedv == item.codpedv" :pedv="item" @closeform="pedv_update_status = {}" @save="handlePostStatus"></pedido-status>
                                    <pedido-status-share v-if="pedv_share_status.codpedv == item.codpedv" :pedv="item" @closeform="pedv_share_status = {}" @save="handlePostShareStatus"></pedido-status-share>
                                </div>
                                <div class="col-12 mb-2">
                                    <span class="badge badge-error mr-2" v-if="appLoja && item.tppedv == 'P' && item.stfraud == '3'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Reprovado Clearsale </span>
                                    <span class="badge badge-success mr-2" v-if="appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.stfraud == '2'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Clearsale </span>
                                    <!-- <span class="badge badge-warning mr-2" v-if="appLoja && item.tppedv == 'P' && (!item.cieloidsuperlink)"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Link pagamento Cielo não gerado </span> -->
                                    <span class="badge badge-warning mr-2" v-if="appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.cieloidsuperlink && item.vendarecebida != 'S' && item.vendarecebida != 'N'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Aguardando Pagamento Online </span>
                                    <span class="badge badge-warning mr-2" v-if="appLoja && item.tppedv == 'P' && item.cieloidsuperlink && item.vendarecebida == 'N'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Pagamento Não realizado </span>
                                    <span class="badge badge-success mr-2" v-if="appLoja && item.tppedv == 'P' && item.vendarecebida == 'S'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Pagamento Efetuado </span>
                                    <span v-if="item.stpedv != 'C' && item.status" class="badge badge-warning" :title="horaStatus(item.datastatus)"> <i class="fa fa-exclamation-circle mr-2" aria-hidden="true"></i> {{ item.status }} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div style="display: none">
            <PedidoImpressao ref="impressao" v-if="showImpressao" :index="codpedvImpressao" @close="handleClosePrint"/>
        </div>

        <fv-pedido-form v-if="showForm" :index="this.codpedv" :crud="this.crud" @closeform="closeForm"></fv-pedido-form>
    </div>
</template>


<style scoped>

.mobile-device {
    display: block;
}

.other-device {
    display: none;
}

@media (min-width: 768px) {
  .mobile-device {
      display: none;
  }
  .other-device {
      display: block;
  }
}

</style>



// WEBPACK FOOTER //
// src/forms-fv/fv-pedido-list.vue